const createWidgetFactory = require('components-framework/widget/create_widget_factory');
import {PriceSummaryModel} from './model';
import {PriceSummaryView} from './view';
const WIDGET_NAME = 'membership_price_summary';

const factory = createWidgetFactory({
    name: WIDGET_NAME,
    modelClass: PriceSummaryModel,
    viewClass: PriceSummaryView,
    methods: {
        initialize() {
            this.render();
        },
        onChangeOffer(isMembershipAdded) {
            this.onChangeOffer(isMembershipAdded);
        },
    },
});

export default {
    factory,
    WIDGET_NAME,
};
